import moment from "moment";

/**
 * Function that should be used for any dates prvided by user in form of a string.
 * Use of moment ascertains that the date is considered as UTC.
 */
export function parseDateString(date: string): Date {
    return moment(date).toDate();
}
